import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Loader2, X } from "lucide-react";

/**
 * Single-decision dialog (approve/reject one request with optional comment).
 */
export function ApprovalDecisionDialog({ open, onClose, onConfirm, busy, comment, onCommentChange }) {
  return (
    <Dialog open={!!open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {open?.action === "approve" ? "Davanje suglasnosti" : "Odbijanje zahtjeva"}
          </DialogTitle>
        </DialogHeader>
        <Textarea
          placeholder="Komentar (opcionalno)"
          value={comment}
          onChange={(e) => onCommentChange(e.target.value)}
          data-testid="decision-comment"
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Odustani</Button>
          <Button onClick={onConfirm} disabled={busy} data-testid="confirm-decision">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
            Potvrdi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

/**
 * Bulk-reject dialog (mandatory reason, applied to all selected items).
 */
export function BulkRejectDialog({ open, count, reason, onReasonChange, onClose, onConfirm, busy }) {
  return (
    <Dialog open={!!open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Bulk odbijanje — {open === "vacation" ? "Godišnji odmor" : "Rad od kuće"}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Razlog odbijanja primijenit će se na sve odabrane zahtjeve ({count}).
        </p>
        <Textarea
          placeholder="Razlog odbijanja (obavezno)"
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          data-testid="bulk-reject-reason"
          rows={4}
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Odustani</Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={busy || !reason.trim()}
            data-testid="confirm-bulk-reject"
          >
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <X className="w-4 h-4 mr-2"/>}
            Odbij sve
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
